import { NextParsedUrlQuery as QueryParams } from 'next/dist/server/request-meta';

import { logMparticleEvent, mParticleCustomEvents } from 'helpers/mParticle';

import { FormContext } from './ratingsSurveyModalTypes';

interface RatingsSurveyAttributes {
  comms_channel: string;
  customer_id?: string;
  experiment_id: string | string[];
  initial_restaurant_star_rating?: number;
  order_id: string | string[];
  restaurant_location_id: string | string[];
  survey_id: string | string[];
  restaurant_star_rating?: number;
  restaurant_reorder_option_order?: string;
  restaurant_reorder_choice?: string;
  restaurant_reorder_reason?: string;
  restaurant_reorder_comments?: string;
}

export function sendEvent(
  queryParams: QueryParams,
  formContext: FormContext,
  eventName: string,
  eventType: number
) {
  const attributes = getEventAttributes(queryParams, formContext, eventName);

  logMparticleEvent({
    eventName,
    eventType,
    attributes,
  });
}

export function getEventAttributes(
  params: QueryParams,
  formContext: FormContext,
  eventName: string
): RatingsSurveyAttributes | {} {
  const values = formContext.getValues();

  const baseAttributes = () => ({
    comms_channel: 'email',
    experiment_id: params.experimentId || '',
    order_id: params.orderId || '',
    restaurant_location_id: params.restaurantId || '',
    survey_id: params.surveyId || '',
  });

  const viewRatingsSurvey = () => ({
    ...baseAttributes(),
    initial_restaurant_star_rating: values['rating'],
  });

  const selectRestaurantReorderChoice = () => ({
    ...baseAttributes(),
    restaurant_reorder_option_order: values['orderAgainQuestionOrder'],
    restaurant_reorder_choice: values['orderAgain'] || '',
  });

  const completeRatingsSurvey = () => ({
    ...baseAttributes(),
    customer_id: params.customerId || '',
    restaurant_star_rating: values['rating'],
    restaurant_reorder_option_order: values['orderAgainQuestionOrder'],
    restaurant_reorder_choice: values['orderAgain'] || '',
    restaurant_reorder_reason: values['orderAgainFollowUp']?.join('-') || '',
    restaurant_reorder_comments: values['orderAgainFollowUpOther'] || '',
  });

  const restaurantSurveyModalClose = completeRatingsSurvey;

  const Events = mParticleCustomEvents;
  const attributeFns = {
    [Events.viewRatingsSurvey]: viewRatingsSurvey,
    [Events.selectRestaurantReorderChoice]: selectRestaurantReorderChoice,
    [Events.completeRatingsSurvey]: completeRatingsSurvey,
    [Events.restaurantSurveyModalClose]: restaurantSurveyModalClose,
  };
  const attributeFn = attributeFns[eventName] || (() => ({}));

  return attributeFn();
}
